export default __webpack_public_path__ + "static/media/juego3_perder.5818fc96.png";